import React from 'react';
import { MessageSquareText, Trophy } from 'lucide-react';
import { GamePhotoStrip } from './GamePhotoStrip';

const OUTCOME = {
  win: { label: 'Patriots Win', className: 'bg-emerald-700 text-white' },
  loss: { label: 'Patriots Fall', className: 'bg-[#0a1f44] text-white' },
  tie: { label: 'Tie Game', className: 'bg-[#d97706] text-white' },
};

export const opponentShortName = (game) => (game.opponent || 'Opponent').split(' ')[0].toUpperCase();

const formatGameDate = (date) => new Date(`${date}T12:00:00`).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });

export const finalScoreText = (game) => {
  const { result } = game;
  const headline = result.outcome === 'win' ? 'Patriots WIN!' : result.outcome === 'tie' ? 'Patriots tie' : 'Final';
  const opponent = game.opponent || 'Opponent';
  const parts = [`${headline} Brookline JP Patriots ${result.patriotsScore} – ${opponent} ${result.opponentScore} (${formatGameDate(game.date)})`];
  if (result.recap) parts.push(result.recap);
  parts.push(`${window.location.origin}/announcements#game-results`);
  return parts.join(' · ');
};

export const finalScoreSmsHref = (game) => `sms:?&body=${encodeURIComponent(finalScoreText(game))}`;

export const TextFinalScoreButton = ({ game, className = '' }) => (
  <a href={finalScoreSmsHref(game)} data-testid={`game-result-text-${game.id}`} className={`inline-flex items-center justify-center gap-1.5 border px-3 py-2 font-heading uppercase tracking-widest text-[10px] transition-colors ${className}`}>
    <MessageSquareText className="w-3.5 h-3.5" aria-hidden="true" /> Text the Final Score
  </a>
);

export const GameResultBadge = ({ game, compact = false }) => {
  if (!game?.result) return null;
  const { result } = game;
  const outcome = OUTCOME[result.outcome] || OUTCOME.tie;
  return (
    <div data-testid={`game-result-${game.id}`} data-outcome={result.outcome} className={`border-l-4 border-[#c8102e] ${outcome.className} ${compact ? 'px-3 py-2' : 'px-4 py-3'}`}>
      <div className="flex items-center gap-1.5 font-heading uppercase tracking-[0.3em] text-[9px] opacity-75"><Trophy className="w-3 h-3" aria-hidden="true" /> Final · {outcome.label}</div>
      <div className={`font-display tabular-nums leading-none mt-1 ${compact ? 'text-xl' : 'text-2xl sm:text-3xl'}`} data-testid={`game-result-${game.id}-score`}>
        BJP {result.patriotsScore} – {opponentShortName(game)} {result.opponentScore}
      </div>
      {result.recap && <p className="text-xs sm:text-sm opacity-90 mt-1.5" data-testid={`game-result-${game.id}-recap`}>{result.recap}</p>}
      <GamePhotoStrip game={game} compact={compact} />
      {!compact && <TextFinalScoreButton game={game} className="mt-3 border-white/60 bg-white/10 text-white hover:bg-white hover:text-[#0a1f44]" />}
    </div>
  );
};
